import { IGroupSearch } from '@/client/legacy-shared-modules/search/search-types';

import { orderRecordsByIds } from '../../utils/contentHelpers';
import { SearchAIResults_GroupsByIds_groupsByIds_results } from '../../graphql-types/SearchAIResults_GroupsByIds';

export function mapGroupsByIdsToGroupHits(
  groups: SearchAIResults_GroupsByIds_groupsByIds_results[],
  orderedGroupIds: string[]
): IGroupSearch[] {
  return orderRecordsByIds(groups, orderedGroupIds).map((group) => ({
    scope: [],
    objectID: group._id,
    name: group.name?.trim() || 'Group',
    description: group.description?.trim() ?? '',
    totalMembers: group.totalMembers ?? 0,
    profilePictureUrl: group.profileImage?.imageProxy ?? null,
  }));
}
